/*
 * @providesModule PlayerLevelUpModalStyle
 * 
 */

import _ from 'lodash';
import Sizes from 'Sizes';
import SkillzStyle from 'SkillzStyle';

import {
  StyleSheet,
} from 'react-native';

const {
  btnTextColorOne,
  fontRegular,
  fontSecondary,
  fontSizeH2,
  fontSizeH3,
  fontSizeH4,
  textColorSecondary,
  viewDividerColorTwo,
} = SkillzStyle.fullStyles;

const sharedStyles = {
  contentContainer: {
    backgroundColor: 'transparent',
    justifyContent: 'space-between',
    maxHeight: Sizes.screenHeight - 64, // eslint-disable-line no-magic-numbers
  },

  contentContainerLandscape: {
    backgroundColor: 'transparent',
    justifyContent: 'space-between',
  },

  progressContainer: {
    marginTop: 12,
  },

  subtitle: {
    ...fontRegular,
    ...fontSizeH2,
    ...textColorSecondary,
    textAlign: 'center',
    marginHorizontal: 6
  },

  subtitleLandscape: {
    ...fontRegular,
    ...fontSizeH2,
    ...textColorSecondary,
    textAlign: 'center',
    marginHorizontal: 6
  },

  buttonContainer: {
    marginTop: 12,
    marginHorizontal: 12,
    marginBottom: 28,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },

  compactButton: {
    width: Sizes.select({smallPhone: 108, largePhone: 126, other: 126,}),
    height: 35,
    marginHorizontal: 6,
  },

  compactButtonText: {
    ...fontSizeH4,
    ...fontSecondary,
    ...btnTextColorOne,
  },

  largeButton: {
    alignSelf: 'stretch',
    flex: 1,
    marginHorizontal: 70,
  },

  largeButtonText: {
    ...fontSizeH3,
    ...fontSecondary,
    ...btnTextColorOne,
  },
};

const withBody = {

  modalStyle: {
    ...Sizes.select({
      portraitTablet: {
        width: 350
      },
      other: {},
    }),
  },

  modalStyleLandscape: {
    width: 520,
    maxWidth: Sizes.screenHeight * 0.9, // eslint-disable-line no-magic-numbers
  },

  contentContainer: {},
    
  contentContainerLandscape: {
    flexDirection: 'row',
    maxHeight: Sizes.screenWidth - 64, // eslint-disable-line no-magic-numbers
  },

  leftPane: {
    width: '40%',
    justifyContent: 'center',
  },

  rightPane: {
    flex: 1,
    justifyContent: 'center',
  },

  pad: {
    flex: 0.4,
  },

  subtitle: {
    marginVertical: 16,
    ...fontSizeH2,
  },

  subtitleLandscape: {
    marginVertical: 16,
    ...fontSizeH3,
  },

  divider: {
    ...viewDividerColorTwo,
    alignSelf: 'stretch',
    marginHorizontal: 12,
    height: 1,
    opacity: 0.5,
  },

  dividerLandscape: {
    opacity: 0.5,
  },

  verticalDivider: {
    ...viewDividerColorTwo,
    alignSelf: 'stretch',
    marginVertical: 12,
    width: 1,
    opacity: 0.5,
  },

  bodyText: {
    ...Sizes.select({
      portraitPhone: fontSizeH4,
      other: fontSizeH3,
    }),
    marginVertical: 16,
    ...textColorSecondary,
    ...fontRegular,
    textAlign: 'center',
    marginHorizontal: Sizes.select({portraitTablet: 26, other: 8,}),
    alignSelf: 'center',
  },

  bodyTextLandscape: {
    ...fontSizeH3,
    ...textColorSecondary,
    ...fontRegular,
    textAlign: 'center',
    marginHorizontal: 8,
    alignSelf: 'center',
  }
};

const withoutBody = {
  contentContainer: {},

  modalStyle: {
    ...Sizes.select({
      portraitTablet: {
        width: 350
      },
      other: {},
    }),
  },

  subtitle: {
    ...fontSizeH2,
  },
};

export default function getStyles(hasBody: boolean): StyleSheet {
  let modifier = withBody;
  if (!hasBody) {
    modifier = withoutBody;
  }
  const bucket = {};
  _.merge(bucket, sharedStyles, modifier);
  return StyleSheet.create(bucket);
}
